export default "__VITE_ASSET__029f339d__"